import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormGroupWrapperComponent } from './form-group.component';

const declarations = [FormGroupWrapperComponent];

const imports = [ReactiveFormsModule, FormlyModule.forChild()];

@NgModule({
	imports,
	declarations,
	exports: [...declarations]
})
export class FormGroupModule {}
